/* Requires the verified, localized public campaign state. Not a standalone activation. */
(function () {
  'use strict';
  if (window.__IIG_PROMOTION_PLACEMENT__) return;
  window.__IIG_PROMOTION_PLACEMENT__ = true;
  function sync() {
    var state = window.IIGPromotionState ? window.IIGPromotionState.read() : null;
    var active = !!(state && state.active === true && typeof state.title === 'string' && state.title.trim() && typeof state.terms === 'string' && state.terms.trim());
    if (!active) document.querySelectorAll('.lp-complete-look-modal[open]').forEach(function (modal) { if (typeof modal.hide === 'function') modal.hide(); });
    document.querySelectorAll('[data-iig-complete-look]').forEach(function (element) {
      if (!active) {
        element.hidden = true;
        element.style.setProperty('display', 'none', 'important');
        return;
      }
      var title = element.querySelector('.lp-complete-look-promo__title');
      // The theme moves modal-dialog out of the placement into document.body.
      var modalId = element.getAttribute('data-iig-promotion-modal');
      var modal = modalId ? document.getElementById(modalId) : null;
      var terms = modal ? modal.querySelector('.lp-complete-look-modal__body') : null;
      if (!title || !terms) {
        element.hidden = true;
        element.style.setProperty('display', 'none', 'important');
        return;
      }
      if (title.textContent !== state.title) title.textContent = state.title;
      if (terms.textContent !== state.terms) terms.textContent = state.terms;
      terms.style.whiteSpace = 'pre-line';
      // A renewed campaign is not automatically in its last days.
      element.querySelectorAll('.lp-complete-look-promo__last-days').forEach(function (node) { node.hidden = true; });
      element.hidden = false;
      element.style.removeProperty('display');
    });
  }
  window.addEventListener('iig:promotion-state', sync);
  document.addEventListener('visibilitychange', sync);
  if (document.body) new MutationObserver(sync).observe(document.body, { childList: true, subtree: true });
  sync();
})();
